module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("官网活动")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("学生作品管理")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-postion": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "手机号"
    }
  }, [_c('Input', {
    attrs: {
      "name": "mobile"
    },
    model: {
      value: (_vm.queryParam.mobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "mobile", $$v)
      },
      expression: "queryParam.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名"
    }
  }, [_c('Input', {
    attrs: {
      "name": "userName"
    },
    model: {
      value: (_vm.queryParam.userName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userName", $$v)
      },
      expression: "queryParam.userName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "所属学导"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser"
    },
    model: {
      value: (_vm.queryParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyAdviserId", $$v)
      },
      expression: "queryParam.studyAdviserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "作品名称"
    }
  }, [_c('Input', {
    attrs: {
      "name": "title"
    },
    model: {
      value: (_vm.queryParam.title),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "title", $$v)
      },
      expression: "queryParam.title"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "分组"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.ageGroup),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "ageGroup", _vm._n($$v))
      },
      expression: "queryParam.ageGroup"
    }
  }, _vm._l((_vm.$constant.userVideoType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "期数"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.period),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "period", _vm._n($$v))
      },
      expression: "queryParam.period"
    }
  }, _vm._l((_vm.$constant.userVideoPeriod), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否已上传作品",
      "prop": "isUploadVideo"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.isUploadVideo),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isUploadVideo", _vm._n($$v))
      },
      expression: "queryParam.isUploadVideo"
    }
  }, [_c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("是")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "审核状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.auditStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "auditStatus", _vm._n($$v))
      },
      expression: "queryParam.auditStatus"
    }
  }, _vm._l((_vm.$constant.auditStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "大众口碑分",
      "prop": "hasPublicScore"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.hasPublicScore),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "hasPublicScore", _vm._n($$v))
      },
      expression: "queryParam.hasPublicScore"
    }
  }, [_c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("是")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Row', [_c('Col', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onAdd
    }
  }, [_vm._v("上传作品")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchToNextRound
    }
  }, [_vm._v("进入下一轮")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/userVideo/pageList",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    },
    on: {
      "on-selection-change": _vm.selectedChange
    }
  }), _vm._v(" "), _c('AddUserVideoModal', {
    attrs: {
      "value": _vm.showAddUserVideoModal,
      "successCallback": _vm.search
    },
    on: {
      "on-close": function($event) {
        _vm.showAddUserVideoModal = false
      }
    }
  }), _vm._v(" "), _c('EditUserVideoModal', {
    attrs: {
      "value": _vm.showEditUserVideoModal,
      "itemId": _vm.itemId,
      "successCallback": _vm.search
    },
    on: {
      "on-close": function($event) {
        _vm.showEditUserVideoModal = false
      },
      "on-edit-clearid": _vm.clearid
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f11eab1","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/activity/UserVideoList.vue
// module id = 1806
// module chunks = 8